<template>
  <v-app>

    <div ref="mapContainer" style="height: 100dvh; z-index: 0;" id="mainmap">
      <AppLogo> </AppLogo>
      <LayerUI @addLayerToMap="addLayerToMap" @toggleLayerVisibility="toggleLayerVisibility" @addCoverageLayerToMap="addCoverageLayerToMap" @toggleCoverageLayerVisibility="toggleCoverageLayerVisibility" @fitBoundsToBBOX="fitBoundsToBBOX" > </LayerUI>
      <!--<IndicatorUI @addStyleExpressionByYear="addStyleExpressionByYear"  @addLayerToMap="addLayerToMap" @toggleLayerVisibility="toggleLayerVisibility" @removeLayerFromMap="removeLayerFromMap" @addDeckglLayer="addDeckglLayer" @updateDeckglLayer="updateDeckglLayer" > </IndicatorUI>-->
      <LegendUI @setFilterForLegendInteraction="setFilterForLegendInteraction" @resetFilter="resetFilter" @zoomIn="zoomIn" @zoomOut="zoomOut" @addLayerToMap="addLayerToMap" @removeLayerFromMap="removeLayerFromMap" @fitBoundsToBBOX="fitBoundsToBBOX"></LegendUI>
      <!--<MenuUI @addLayerToMap="addLayerToMap"  @removeLayerFromMap="removeLayerFromMap" @fitBoundsToBBOX="fitBoundsToBBOX"></MenuUI>-->
      <TimeSliderUI @performTimeSlider="performTimeSlider"></TimeSliderUI>
      <AppHeader @addLayerToMap="addLayerToMap"  @removeLayerFromMap="removeLayerFromMap" @fitBoundsToBBOX="fitBoundsToBBOX"></AppHeader>
       <!--<CartographyUI v-if="catographyUIVisibility==true" @setLayerPintProperty="setLayerPintProperty"  @addLayerToMap="addLayerToMap" @setLayerLayoutProperty="setLayerLayoutProperty" @removeLayerFromMap="removeLayerFromMap" @setLayerZoomrange="setLayerZoomrange"></CartographyUI>-->
      <DatasetSearchUI v-if="mapIsLoaded==true" @updateDeckglLayer="updateDeckglLayer" @addDeckglLayer="addDeckglLayer" @moveLayerToTop="moveLayerToTop" @toggleLayerVisibilityWithValue="toggleLayerVisibilityWithValue" @setLayerPintProperty="setLayerPintProperty" @setLayerLayoutProperty="setLayerLayoutProperty"  @addLayerToMap="addLayerToMap" @fitBoundsToBBOX="fitBoundsToBBOX" @toggleLayerVisibility="toggleLayerVisibility" @removeLayerFromMap="removeLayerFromMap" @addStyleExpressionByYear="addStyleExpressionByYear" @addExternaWMSLayerToMap="addExternaWMSLayerToMap" @addTernaryLayerToMap="addTernaryLayerToMap" @addSensorThingsLayerToMap="addSensorThingsLayerToMap" @removeSensorThingsLayerFromMap="removeSensorThingsLayerFromMap" @handleLayersReordered="handleLayersReordered"></DatasetSearchUI>
       <TutorialUI :map="map"></TutorialUI>
    </div>
  </v-app>
  <AlertUI> </AlertUI>
  <MapExport @export-map="onExportMap"> </MapExport>
  <MapShare > </MapShare>
  <MapImport @addGeojsonToMap="addLayerToMap" @fitBoundsToBBOX="fitBoundsToBBOX" @addWmsToMap="addExternaWMSLayerToMap"> </MapImport>

  <ProgressUI> </ProgressUI>
  
</template>

<script setup>
import { Map, AttributionControl } from 'maplibre-gl';
import { ref, onMounted, onUnmounted } from "vue";
import { storeToRefs } from 'pinia'
import { useMapStore } from '../stores/map'
import AppLogo from "@/components/AppLogo.vue";
import LayerUI from "@/components/LayerUI.vue";
//import IndicatorUI from "@/components/IndicatorUI.vue";
import LegendUI from "@/components/LegendUI.vue";
//import MenuUI from "@/components/MenuUI.vue";
import AlertUI from "@/components/AlertUI.vue";
import MapExport from "@/components/MapExport.vue";
import MapShare from "@/components/MapShare.vue";
import MapImport from "@/components/MapImport.vue";
import ProgressUI from "@/components/ProgressUI.vue";
import TimeSliderUI from "@/components/TimeSliderUI.vue";
import AppHeader from "@/components/AppHeader.vue";
//import CartographyUI from "@/components/CartographyUI.vue";
import DatasetSearchUI from "@/components/DatasetSearchUI.vue";
import TutorialUI from '@/components/TutorialUI.vue';

import { addPopupToMap, addHoverPopup, removeHoverPopup, addWMSLayerFromExternalProvider, getSelectedFeatureInfo,/*addWMSLayerToMap, toggleWMSLayerVisibility*/ 
addZoomOnClusterLayer,
addOnClickSensorThingsLayer,
addCursorStyleHovering} from '../utils/mapUtils';
import { useChartStore } from '../stores/chart'
//import { useCartographyStore } from '../stores/cartography'

import { setMapFilterForLegendInteraction } from '../utils/setMapFilterForLegendInteraction';

import { MapboxOverlay } from '@deck.gl/mapbox';
import { ColumnLayer } from '@deck.gl/layers'
import 'maplibre-gl/dist/maplibre-gl.css';
	import {
		MaplibreExportControl,
		Size,
		PageOrientation,
		Format,
		DPI
	} from '@watergis/maplibre-gl-export';
	import '@watergis/maplibre-gl-export/dist/maplibre-gl-export.css';
import { useIndicatorStore } from '@/stores/indicator'
import { useMapCameraDeepLink } from "../utils/useMapCameraDeepLink"
import {getFeatureInstanceFromDB} from "../services/backend.calls";
import { getThings } from '@/services/frost.service';
import { DatasetTypes } from '@/utils/datasetTypes';

let {indicatorArray} = storeToRefs(useIndicatorStore())

const { style, pitch, extent } = storeToRefs(useMapStore())
let { selectedFeature } = storeToRefs(useChartStore())
//let { catographyUIVisibility } = storeToRefs(useCartographyStore())
const mapContainer = ref(null);

let vectorServer = process.env.VUE_APP_GEOSERVER_URL+'/';
let map = null;
let selectedFeatureId = null;
let mapboxOverlayLayer = ref(null)
let exportControl = null
let cameraLink = null
let mapIsLoaded = ref(false)
onMounted(() => {

  map = new Map({
    container: mapContainer.value,
    style: style.value,
    //center: center.value,
    //zoom: zoom.value,
    pitch: pitch.value,
    preserveDrawingBuffer: true,
    attributionControl: false,
    bounds: extent.value,
    fadeDuration: 0,
  });
  
  cameraLink = useMapCameraDeepLink(map)
  cameraLink.attach()
  map.addControl(new AttributionControl({
    customAttribution: '<a href="https://www.fh-potsdam.de/impressum" target="_blank">© Legal Note</a> <a href="https://www.fh-potsdam.de/datenschutz" target="_blank">© Privacy statement</a>',
    compact: true,

  }), 'bottom-left');
  exportControl = new MaplibreExportControl({
		PageSize: Size.A3,
		PageOrientation: PageOrientation.Portrait,
		Format: Format.PDF,
		DPI: DPI[96],
		Crosshair: true,
		PrintableArea: true,
		Local: 'de',
		
	});
  map.addControl(exportControl, "bottom-left");
  map.on('load', () => {
    mapIsLoaded.value = true
  });

})

const onExportMap = (payload)=> {
  if (exportControl) {
    map.removeControl(exportControl);
  }

 
  const pageSize = Size[payload.selectedPageSize.toUpperCase()] || Size.A4;
  const pageOrientation = PageOrientation[payload.selectedPageOrientation] || PageOrientation.Landscape; // or make dynamic if needed
  const format = Format[payload.selectedFormat.toUpperCase()] || Format.PNG;
  const dpi = DPI[payload.selectedDPI] || DPI[96];

  exportControl = new MaplibreExportControl({
    PageSize: pageSize,
    PageOrientation: pageOrientation,
    Format: format,
    DPI: dpi,
    Crosshair: true,
    PrintableArea: true,
    Local: "de",
  });

  // Add control to the map (needed to initialize button and internal map reference)
  map.addControl(exportControl);
  const btn = document.getElementsByClassName('generate-button')[0];

  if (btn) {
    btn.click(); // Programmatically click the button
  } else {
    console.error("Export button not found in DOM");
  }
  
 
}
const addLayerToMap = (layerSpecification)=>{
  let vectorSourceLayer = layerSpecification.layerNameInDatabase;
  let vectorUrl = vectorServer + 'gwc/service/tms/1.0.0/brandenburg:' + vectorSourceLayer + '@EPSG%3A900913@pbf/{z}/{x}/{y}.pbf';
  
  const layerId = layerSpecification.id;

  // 1. CLEAR EXISTING LAYER AND SOURCE IF THEY EXIST
  // This allows the new layer to claim the exact same ID cleanly
  if (layerSpecification.sourceType == DatasetTypes.SensorThings) {
    return;
  } else {
    if (map.getLayer(layerId) !== undefined) {
      map.removeLayer(layerId);
    }
    if (map.getSource(layerId) !== undefined) {
      map.removeSource(layerId);
    }
  }
  

  // 2. ADD SOURCE
  if (layerSpecification.sourceType == "vector_tile") {
    map.addSource(layerId, {
        "type": "vector",
        "scheme": 'tms',
        "tiles": [vectorUrl],
        "promoteId": 'nationalco',
        "minzoom": 0,
        "maxzoom": 22
    });
    
    // 3. ADD VECTOR LAYER
    let layer = {
        "id": layerId,
        "source": layerId,
        "source-layer": vectorSourceLayer,
        "type": layerSpecification.layerType.value,
        "paint": layerSpecification.style.value,
        "layout": layerSpecification.layout?.value || {}
    };
    map.addLayer(layer);
  } 
  else if (layerSpecification.sourceType == "geojson") {
    console.log(layerId, "added Layer ID")
    map.addSource(layerId, {
      'type': 'geojson',
      'data': layerSpecification.geoGjsonData
    });
    
    // 3. ADD GEOJSON LAYER
    let layer = {
        "id": layerId,
        "source": layerId,
        "type": layerSpecification.layerType.value,
        "paint": layerSpecification.style.value,
        "layout": layerSpecification.layout?.value || {}
    };
    map.addLayer(layer);  
  }

  // 4. ATTACH INTERACTIONS
  map.on('click', layerId, async function(e) {
    if (layerId.includes('kommunales_gebiet_dashboard') || layerId == 'kommunales_gebiet_centroid'){
      selectedFeature.value = getSelectedFeatureInfo(e, layerSpecification, indicatorArray)
      removeLayerFromMap({layerId: "highlight", sourceId: "highlight"})
      addPopupToMap(map, layerId, vectorSourceLayer, selectedFeatureId, e)
      addHighlightLayer(layerSpecification.layerNameInDatabase, e.features[0].properties.nationalco, layerId)
    }
    else {
      addPopupToMap(map, layerId, vectorSourceLayer, selectedFeatureId, e)
    }
  });

  map.on('mouseenter', layerId, function() {
    map.getCanvas().style.cursor = 'pointer';
  });
  map.on('mouseleave', layerId, function() {
    map.getCanvas().style.cursor = '';
  });

  map.on('mousemove', 'kommunales_gebiet_dashboard', (e) => {
    addHoverPopup(map, e)
  });
  map.on('mouseleave', 'kommunales_gebiet_dashboard', () => {
    removeHoverPopup(map)
  });
}
const addHighlightLayer = async (tablename, featureId, layerId)=>{
  const featureInstance = await getFeatureInstanceFromDB({tablename: tablename, featureId:featureId})
      if(map.getSource("highlight")==undefined){
        map.addSource( "highlight",{"type": "geojson", data: featureInstance.features[0]})
        map.addLayer({
          'id': 'highlight',
          'type': layerId.includes('kommunales_gebiet_dashboard') ? 'line': 'circle',
          'source': 'highlight',
          'paint': layerId.includes('kommunales_gebiet_dashboard')? {
            'line-color': '#888',
            'line-width': 3,
            "line-dasharray": [0.5, 2],
          }: {
            'circle-color': '#00FF00',
            'circle-stroke-color':  '#888',
            'circle-stroke-width': 3,
            'circle-opacity': 1,
            'circle-radius':featureInstance.features[0].layer.paint['circle-radius']

          },
          'layout': layerId.includes('kommunales_gebiet_dashboard')? {
            'line-cap': 'round',
          
          }: {
            

          },
        });
      
      }
  
}
const getMapLayerId = (metadata) => {
    if (metadata.dct_type === 'raster') {
        return metadata.dct_title;
    }

    else if (metadata.dct_type === 'indikator') {
        return `kommunales_gebiet_dashboard${metadata.dct_title}` +'_'+`${metadata.dcatde_politicalgeocodingleveluri}`;
    }
    else if (metadata.dct_type === 'geojson') {
        return metadata.dct_title;
    }




    return null;
};
const handleLayersReordered = (newOrder) => {

    const mapOrder = [...newOrder].reverse();

    mapOrder.forEach(layer => {

        const layerId = getMapLayerId(layer);

        if (!layerId) return;

        if (!map.getLayer(layerId)) {
            console.warn("MapLibre layer NOT FOUND:", layerId);
            return;
        }

        map.moveLayer(layerId);
    });
};
const addStyleExpressionByYear = (layerId, styleProperty, fillStyle)=>{   
  map.setPaintProperty(
    layerId,
    styleProperty,
    fillStyle
  );
  
}
const setLayerPintProperty = (layerId, styleProperty, fillStyle)=>{
  map.setPaintProperty(
    layerId,
    styleProperty,
    fillStyle
  );
}
const setLayerLayoutProperty = (layerId, layoutProperty, layoutValue)=>{
  map.setLayoutProperty(
    layerId,
    layoutProperty,
    layoutValue
  );
}
/*const setLayerZoomrange = (layerId, minZoom, maxZoom)=>{
  map.setLayerZoomRange(layerId, minZoom, maxZoom);
}*/

const toggleLayerVisibility = (clickedLayerName)=>{
  if(map.getSource(clickedLayerName)!=undefined){
      let visibility = map.getLayoutProperty(
        clickedLayerName,
        'visibility'
        );

      if (visibility == 'visible'){
        map.setLayoutProperty(clickedLayerName,'visibility', 'none')
      }
      else if (visibility == undefined){
        map.setLayoutProperty(clickedLayerName,'visibility', 'none')
      }
      else {
        map.setLayoutProperty(clickedLayerName,'visibility', 'visible')
      }

  }
   
}
const toggleLayerVisibilityWithValue = (clickedLayerName, visValue)=>{
  if(map.getSource(clickedLayerName)!=undefined){
     
        map.setLayoutProperty(clickedLayerName,'visibility', visValue)
     
  }
}
/*const addCoverageLayerToMap = (clickedLayerName, layerType, style) =>{
  addWMSLayerToMap(map, clickedLayerName, layerType, style)
}*/
/*const toggleCoverageLayerVisibility = (clickedLayerName)=>{
  toggleWMSLayerVisibility(map, clickedLayerName)
}*/

const addExternaWMSLayerToMap = (layerSpecification)=>{
  addWMSLayerFromExternalProvider(map, layerSpecification)
}
const setFilterForLegendInteraction = (payload) => {
  setMapFilterForLegendInteraction(map, payload)
}

const resetFilter = (payload) => {
  let mapLayer = map.getLayer(payload.layerId);
  if(typeof mapLayer !== 'undefined') {
    map.setFilter(payload.layerId, null);
  }
 
}

const removeLayerFromMap = (payload) => {
  
  let mapLayer = map.getLayer(payload.layerId);
  if(typeof mapLayer !== 'undefined') {
    map.removeLayer(payload.layerId).removeSource(payload.sourceId);
  }
}



const fitBoundsToBBOX = (bbox)=>{
  map.fitBounds([
    [bbox[0], bbox[1]], // [lng, lat] - southwestern corner of the bounds
    [bbox[2], bbox[3]] // [lng, lat] - northeastern corner of the bounds
  ]);
}
function convertRange( value, r1, r2 ) { 
    return ( value - r1[0] ) * (r2[1] - r2[0]) / (r1[1] - r1[0]) + r2[0];
}
const addDeckglLayer = (data, style) => {
  

  const values = data.features.map(f => f.properties.calculatedWert);
  // Filter out non-numeric values
  const numericValues = values.filter(value => typeof value === 'number' && !isNaN(value) && value !== Infinity && value !== undefined);

  let min
  let max
  if (numericValues.length > 0) {
     min = Math.min(...numericValues);
     max = Math.max(...numericValues);
  }
  
  mapboxOverlayLayer.value = new MapboxOverlay({
    interleaved: true,
    layers: [
      new ColumnLayer({
        id: "custom-indicator-layer",
        data: data.features,
        getPosition: f => f.geometry.coordinates,
        pickable: false,
        visible: true,
        radius: 1000,
        extruded: true,
        coverage: 1,
        upperPercentile: 100,
        autoHighlight: true,
        elevationRange: [0, 3000],
        getFillColor: f => style(f.properties.calculatedWert),
        elevationScale: 100,
        getElevation: d => convertRange(d.properties.calculatedWert, [ min, max ], [ 0, 2000 ]),
        transitions: {
          getElevation: {duration: 1000, enter: () => [0]},
        }        
      })
    ]
  });
  map.addControl(mapboxOverlayLayer.value);
  let current_pitch = map.getPitch()
  if (current_pitch==0){
    map.easeTo({
      speed: 0.4,
      curve: 1,
      duration: 1000,
      pitch: 40,
      easing(t) {
          return t;
      }
    });
  }
  
}

const updateDeckglLayer = (data, style) =>{
  if (mapboxOverlayLayer.value ) {
    map.removeControl(mapboxOverlayLayer.value);
    addDeckglLayer(data, style);
  }

}
const performTimeSlider = (data)=>{
  addStyleExpressionByYear(data.layer, data.paint_property, data.expression)
}

const moveLayerToTop = (layerId)=>{
  if (map.getLayer(layerId)) {
        // Move the layer to the top
        map.moveLayer(layerId);
    } else {
        console.error(`Layer with ID '${layerId}' does not exist.`);
    }
}

/**
 * Add Layers for SensorThings data (including clustered layers)
 * @param observedProperty metadata object (including observedPropertyId field)
 */
const addSensorThingsLayerToMap = async (observedProperty) => {
  const things = await getThings(observedProperty.observedPropertyId);
  // Used as source name and prefix for layer names
  const layerName = observedProperty.dct_title;
  
  // Stop if Source already exists
  if (map.getSource(layerName) != undefined) {
    return;
  }

  // Add as source to the map
  map.addSource(layerName, {
    'type': 'geojson',
    'data': things,
    cluster: true,
    clusterRadius: 20, // cluster two trailheads if less than 20 pixels apart
    clusterMaxZoom: 14 // display all trailheads individually from zoom 14 up
  });

  // Add Cluster layer
  map.addLayer({
    id: layerName + '-clusters',
    type: 'circle',
    source: layerName,
    filter: ['has', 'point_count'],
    paint: {
        'circle-color': '#11b4da',
        'circle-radius': 10
    },
  });

  map.addLayer({
    id: layerName + 'cluster-count',
    type: 'symbol',
    source: layerName,
    filter: ['has', 'point_count'],
    layout: {
        'text-field': '{point_count_abbreviated}',
        'text-font': ['Noto Sans Regular'],
        'text-size': 12
    }
  });

  // Add unclustered/ single item layer
  map.addLayer({
    id: layerName + '-unclustered',
    type: 'circle',
    source: layerName,
    filter: ['!', ['has', 'point_count']],
    paint: {
        'circle-color': '#11b4da',
        'circle-radius': 5,
        'circle-stroke-width': 1,
        'circle-stroke-color': '#fff'
    }
  });

  addCursorStyleHovering(map, layerName + '-unclustered');
  addCursorStyleHovering(map, layerName + '-clusters');

  addZoomOnClusterLayer(map, layerName + "-clusters", layerName);

  addOnClickSensorThingsLayer(map, layerName + '-unclustered', selectedFeature);
}

const removeSensorThingsLayerFromMap = (layerName) => {
  console.log("Removing layer: " + layerName)
  map.removeLayer(layerName + '-clusters');
  map.removeLayer(layerName + 'cluster-count');
  map.removeLayer(layerName + '-unclustered');
  map.removeSource(layerName);
}

onUnmounted(() => {
  if (map) {
    map.remove();
  }
  if (cameraLink) cameraLink.detach()
  if (map) map.remove()
});

const zoomIn = ()=>{
  const currentZoom = map.getZoom();
  map.zoomTo(currentZoom + 0.5);
}
const zoomOut = ()=>{
  const currentZoom = map.getZoom();
  map.zoomTo(currentZoom - 0.5);
}

const addTernaryLayerToMap = (data)=>{

    const layerId = 'kommunales_gebiet_dashboard'+data.existingSourceId
   
    const vectorSourceLayer = data.granularity
    if (!map.getLayer(layerId)) {
      console.warn("Layer does not exist.")
      return
    }

    const layer = map.getLayer(layerId);
    if (!layer) {
        console.warn("Layer not found");
        return;
    }

    const colorExpression = [
      "case",
      ["!=", ["feature-state", "share1"], null],
      [
          "rgb",
          ["*", 255, ["feature-state", "share1"]],
          ["*", 255, ["feature-state", "share2"]],
          ["*", 255, ["feature-state", "share3"]]
      ],
      "#cccccc"
    ];
    let vectorSourceLayerId
  if (layer.type === "fill") {
    vectorSourceLayerId = vectorSourceLayer
    map.setPaintProperty(layerId, "fill-color", colorExpression);
    map.setPaintProperty(layerId, "fill-opacity", 1);
    map.setPaintProperty(layerId, "fill-outline-color", "grey");
  }
  else if (layer.type === "circle") {
    vectorSourceLayerId = vectorSourceLayer+'_centroid'
    map.setPaintProperty(layerId, "circle-color", colorExpression);
    map.setPaintProperty(layerId, "circle-opacity", 1);
    map.setPaintProperty(layerId, "circle-stroke-color", "grey");
  }

  // Now set feature-state
  data.ternaryData.forEach(row => {
    map.setFeatureState(
      {
        source: layerId,
        sourceLayer: vectorSourceLayerId,
        id: row.kennziffer
      },
      {
        share1: row.share1,
        share2: row.share2,
        share3: row.share3
      }
    )
  })
    

}

</script>

<style scoped>
  ::v-deep .maplibregl-popup-content {
    border-radius:10px;
    width: 100% !important;
    background: rgba(255,255,255,0.6);
    backdrop-filter: blur(5px);
    animation: easeOutElastic 0.5s;
    border: 1px solid rgba(0, 0, 0, 0.2);   
  }
  ::v-deep .maplibregl-popup {
    /* Allow the popup to expand dynamically up to 300px */
    max-width: 300px !important; 
    /* Prevent it from shrinking too much on tiny mobile screens */
    min-width: 100px; 
}
  @keyframes easeOutElastic {
  0% {
    transform: scale(0.98);
  }
  20% {
    transform: scale(1);
  }
  40% {
    transform: scale(0.99);
  }
  60% {
    transform: scale(1);
  }
  80% {
    transform: scale(0.999);
  }
  100% {
    transform: scale(1);
  }
}
::v-deep .maplibregl-ctrl-group{
  display: none;
}


</style>